<template>
  <div id="dummy-homepage">
    <strong>Warning!</strong> <br />
    There is no page set as user homepage. <br />
    Please add it using "setHomepage" from "@/core/router".
  </div>
</template>
